import I18n from "../../I18n";
import { displayValue } from "./utils/mapperUtils";

const mapCard = (json) => {
    const { RuleID, RuleType, Severity, Description } = json;
    return [
        [{ labels: ["ruleId"], value: displayValue(RuleID), type: "string", basis: "20%" }],
        [
            {
                labels: ["description"],
                value: displayValue(Description),
                type: "string",
                basis: "50%",
            },
        ],
        [
            {
                labels: ["severity"],
                value: Severity == null || Severity === "" ? "N/A" : I18n.translate(`severity-${Severity}`),
                type: "number",
            },
        ],
        [{ labels: ["ruleType"], value: displayValue(RuleType), type: "string" }]
    ];
};

const mapper = (json, card) => {
    return {
        ...json,
        name: json.name,
        shortName: json.name,
        card: card ? mapCard(json) : [],
    };
};

const header = [
    {
        label: ["Identifier"],
        align: "left",
        basis: "20%",
        columnName: "RuleID",
        sortable: true,
    },
    {
        label: ["Description"],
        align: "left",
        basis: "50%",
        columnName: "Description",
        sortable: true,
    },
    {
        label: ["Severity"],
        align: "center",
        columnName: "Severity",
        sortable: true,
    },
    {
        label: ["Rule Type"],
        align: "left",
        columnName: "RuleType",
        sortable: true,
    }
];

const ncruleMapper = {
    map: mapper,
    header,
};

export default ncruleMapper;
